import { render, staticRenderFns } from "./SettingDirection.vue?vue&type=template&id=09ab4a38&scoped=true&lang=pug&"
import script from "./SettingDirection.vue?vue&type=script&lang=js&"
export * from "./SettingDirection.vue?vue&type=script&lang=js&"
import style0 from "./SettingDirection.vue?vue&type=style&index=0&id=09ab4a38&prod&lang=scss&scoped=true&"
import style1 from "./SettingDirection.vue?vue&type=style&index=1&id=09ab4a38&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ab4a38",
  null
  
)

export default component.exports